// extracted by mini-css-extract-plugin
export default {"ModalIdle":"ModalIdle_ModalIdle__Ij8EK","Warning":"ModalIdle_Warning__YaRz+","ModalIdle__footer":"ModalIdle_ModalIdle__footer__I7YHX"};